import React from 'react';
import { Inbox } from 'lucide-react';

interface EmptyTableStateProps {
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

const joinClasses = (...classes: Array<string | undefined | false>) =>
  classes.filter(Boolean).join(' ');

const EmptyTableState: React.FC<EmptyTableStateProps> = ({
  title,
  description,
  action,
  icon,
  className,
}) => (
  <div className={joinClasses('empty-table-state', className)}>
    <span className="empty-table-icon">{icon || <Inbox size={22} aria-hidden="true" />}</span>
    <strong>{title}</strong>
    {description ? <p>{description}</p> : null}
    {action ? <div className="empty-table-action">{action}</div> : null}
  </div>
);

export default EmptyTableState;
